import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useI18n } from "@/i18n";
import Navbar from "@/components/Navbar";
import { Search as SearchIcon } from "lucide-react";

export default function Search() {
  const { t, lang } = useI18n();
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    const id = setTimeout(async () => {
      if (!q.trim()) { setResults([]); return; }
      setTouched(true);
      try {
        const { data } = await api.get(`/search?q=${encodeURIComponent(q)}&lang=${lang}`);
        setResults(data);
      } catch {}
    }, 250);
    return () => clearTimeout(id);
  }, [q, lang]);

  return (
    <div className="min-h-screen bg-void">
      <Navbar />
      <main className="pt-28 pb-16 max-w-3xl mx-auto px-6" data-testid="search-page">
        <h1 className="font-serif text-5xl text-ink mb-8">{t("search.title")}</h1>
        <div className="relative mb-10">
          <SearchIcon className="absolute left-4 top-1/2 -translate-y-1/2 text-ink-muted" size={20} strokeWidth={1.5} />
          <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder={t("search.placeholder")}
            data-testid="search-input"
            className="w-full bg-surface border border-ink/10 pl-12 pr-4 py-4 text-ink placeholder:text-ink-muted focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors" />
        </div>
        <div className="divide-y divide-ink/5 border-t border-ink/5" data-testid="search-results">
          {results.map((r) => (
            <Link key={r.lesson_id} to={`/lesson/${r.lesson_id}`}
              className="group block py-4 hover:pl-2 transition-all"
              data-testid={`search-result-${r.lesson_id}`}>
              <div className="flex items-baseline justify-between gap-4">
                <span className="text-lg text-ink group-hover:text-gold transition-colors">{r.title}</span>
                <span className="text-xs text-ink-muted shrink-0">{r.module_title}</span>
              </div>
              {r.excerpt && (
                <p className="text-sm text-ink-muted mt-1 leading-relaxed" data-testid="search-excerpt">{r.excerpt}</p>
              )}
            </Link>
          ))}
          {touched && q.trim() && results.length === 0 && (
            <p className="py-6 text-ink-muted" data-testid="search-none">{t("search.none")}</p>
          )}
        </div>
      </main>
    </div>
  );
}
